<template>
  <div>
    <div class="col-12 mb-4">
      <div class="d-flex bg-white shadow-lg p-3 rounded-3 justify-content-between">
        <h3 class="fw-bold">
          <vue-feather type="bar-chart-2" stroke="#652aa3" size="28" class="me-2"></vue-feather>
          Annual Report Summary {{ year }}
        </h3>
        <div class="d-flex align-items-center">
          <span class="">
            <select data="" class="form-select form-control input-group shadow-sm" v-model="year" @change="getAnnualReport">
              <option v-for="year in analytics.years" :key="year" :value="year">Year: {{ year }}</option>
            </select>
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="row mb-4">
          <!-- Chart Area -->
          <div>
            <div v-if="loading" class="text-center py-4">
              <Spinner spinner-class="mb-1" />
            </div>
            <div v-else>
              <!-- Annual Gross Bar Chart -->
              <GrossBarChart
                  :title="grossChartTitle"
                  :data="this.analytics"
              ></GrossBarChart>

              <!-- Annual Deductions Bar Chart -->
              <DeductionsBarChart
                  :data="this.analytics"
                  :title="deductionsChartTitle"
              >
              </DeductionsBarChart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import analyticsService from "@/api/analyticsService";
import GrossBarChart from "@/components/charts/GrossBarChart.vue";
import formatNumber from "@/utils/formatNumber";
import DeductionsBarChart from "@/components/charts/DeductionsBarChart.vue";
import VueFeather from 'vue-feather';

export default {
  name: "AnnualReport",
  components: {DeductionsBarChart, GrossBarChart, VueFeather },

  data() {
    return {
      loading: true,
      analytics: {
        data: {
          months: [],
          grossDataset: [],
          deductionDatasets: []
        }
      },
      year: new Date().getFullYear(),
    }
  },

  methods: {
    formatNumber,
    getAnnualReport: async function () {
      this.loading = true;
      this.analytics = await analyticsService.getAnalytics(this.year);
      this.loading = false;
    },
  },

  created: async function () {
    await this.getAnnualReport();
  },

  computed: {
    grossChartTitle() {
      return `Payroll Annual Summary ${this.year}`
    },
    deductionsChartTitle() {
      return `Deductions Annual Summary ${this.year}`
    }
  }
}
</script>

<style scoped>
.table th, .table td {
  text-align: right;
}
.table th:first-child, .table td:first-child {
  text-align: left;
}

.bg-primary-light {
  background-color: rgba(101, 42, 163, 0.1);
}

.total-card {
  min-width: 230px;
  opacity: 70%;
  transition: all 0.3s ease;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.total-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.text-primary {
  color: #652aa3 !important;
}

.card {
  transition: all 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
</style>
